import Cookies from 'js-cookie'

import { post } from 'sk-axios'

import { ADMIN } from '@/api'

export function loginByUsername(userName, password) {
  const data = {
    userName,
    pwd: password,
    timestamp: new Date().getTime()
  }
  return post(`${ADMIN}/loginAdmin`, data)
}

export function loginByPhone(telephoneNum, verifyCode) {
  const data = {
    telephoneNum: telephoneNum,
    verifyCode: verifyCode,
    timestamp: new Date().getTime()
  }
  return post(`${ADMIN}/loginByPhone`, data)
}

export function loginByFeiShu(code, wspToolClientId) {
  const data = {
    code: code,
    timestamp: new Date().getTime(),
    wspToolClientId: wspToolClientId && wspToolClientId != 'undefined' ? wspToolClientId : null
  }
  return post(`${ADMIN}/getFeiShuUserInfo`, data)
}

export function logout() {
  const data = {
    ticket: Cookies.get('ticket')
  }
  return post(`${ADMIN}/logoutAdmin`, data)
}

export function getUserInfo() {
  return post(`${ADMIN}/getCurrentUserInfo`)
}

export function getOaUserInfo(data) {
  return post(`${ADMIN}/getOaUserInfo`, data)
}

export function changeRoleValue(data) {
  return post(`${ADMIN}/changeRoleValue`, data)
}
